import { X } from 'lucide-react'

export interface TagProps {
  label: string
  /** 'danger' for an attention-worthy tag (e.g. PRD 04's "critical" field
   * badge) - reuses the danger token rather than a separate badge component. */
  variant?: 'neutral' | 'danger'
  /** Renders a small remove (x) button when provided - omit for a purely
   * read-only/display-only tag. */
  onRemove?: () => void
}

// Solid pill for a single document-type requirement tag - distinct from
// StatusPill, which is status-oriented (live/draft/error), not a generic
// content tag. Used for must_have_all items and the items inside each
// must_have_any_of dashed cluster (PRD 02), and for PRD 04's field type/
// critical badges.
export function Tag({ label, variant = 'neutral', onRemove }: TagProps) {
  return (
    <span
      className={
        variant === 'danger'
          ? 'inline-flex items-center gap-1 rounded-pill bg-danger/10 px-2 py-1 text-meta text-danger ring-1 ring-danger'
          : 'inline-flex items-center gap-1 rounded-pill bg-surface-raised px-2 py-1 text-meta text-text-primary'
      }
    >
      {label}
      {onRemove && (
        <button
          type="button"
          aria-label={`Remove ${label}`}
          onClick={onRemove}
          className="text-current opacity-70 hover:opacity-100"
        >
          <X size={12} strokeWidth={1.5} />
        </button>
      )}
    </span>
  )
}
